import { render, staticRenderFns } from "./Userslist.vue?vue&type=template&id=dce54e2c&scoped=true&"
import script from "./Userslist.vue?vue&type=script&lang=js&"
export * from "./Userslist.vue?vue&type=script&lang=js&"
import style0 from "./Userslist.vue?vue&type=style&index=0&id=dce54e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce54e2c",
  null
  
)

export default component.exports